import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppFloatingButton.css';

const WHATSAPP_NUMBER = '+91 8800418585';
const WHATSAPP_LINK =
  'https://wa.me/918800418585?text=Hello%20Shankarshan%20Team%2C%20I%20need%20help%20with%20your%20services.';

const WhatsAppFloatingButton = () => {
  const { pathname } = useLocation();
  const isServiceRoute = pathname.toLowerCase().startsWith('/services/');

  if (!isServiceRoute) {
    return null;
  }

  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
    >
<FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppFloatingButton;
